import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import firebase from "firebase/app";


const firebaseConfig = {
  apiKey: "AIzaSyBF2cIIPGSWGJ_FI8biDNm9gR9BTffQLdo",
  authDomain: "businessintegration-c6796.firebaseapp.com",
  projectId: "businessintegration-c6796",
  storageBucket: "businessintegration-c6796.appspot.com",
  messagingSenderId: "654928125551",
  appId: "1:654928125551:web:e7c66279102673c85af79a"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
